import { render } from "./BpmRewriteLinkedAlert.vue?vue&type=template&id=b80e81d2"
import script from "./BpmRewriteLinkedAlert.vue?vue&type=script&lang=js"
export * from "./BpmRewriteLinkedAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__